import { useCallback, useEffect, useState } from 'react';
import type { Api, SavedDeviceInfo } from '../../api';

/**
 * 개인 주소록(트리의 "내 주소록" 가지 — 나만 보인다, 설계서 §14.20). 종전 주소록 탭(AddressBookView)의 데이터 부분.
 * 실패는 오류 문구로 돌려준다(목록은 비운 채) — 기기 트리 전체를 막지 않는다.
 */
export function useAddressBook(api: Api) {
  const [items, setItems] = useState<SavedDeviceInfo[]>([]);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    try {
      setItems(await api.getAddressBook());
      setError('');
    } catch (e) {
      setError((e as Error).message);
    }
  }, [api]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  /** 추가(같은 코드면 이름만 바뀐다 — 서버 멱등). */
  const add = useCallback(
    async (deviceCode: string, alias: string) => {
      await api.saveDevice(deviceCode, alias);
      await refresh();
    },
    [api, refresh],
  );

  const remove = useCallback(
    async (id: string) => {
      await api.deleteSavedDevice(id);
      await refresh();
    },
    [api, refresh],
  );

  /**
   * 이름 변경 — 별도 경로 없이 **같은 코드로 다시 저장**한다(서버가 (사용자, 코드) 로 upsert → 이름만 바뀜).
   * 뜻을 드러내려고 `add` 와 이름을 나눠 둔다.
   */
  const rename = add;

  return { items, error, refresh, add, rename, remove };
}
